// Deterministic color mapping for keys (e.g., ActivityCode)
// Uses an HSL-based hash to pick a hue per key, then converts to HEX.

function hashStringToInt(str) {
  // Simple FNV-1a inspired hash
  let h = 2166136261 >>> 0;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h >>> 0;
}

function hslToHex(h, s, l) {
  // h: 0-360, s/l: 0-100
  s /= 100;
  l /= 100;
  const k = (n) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n) => {
    const color =
      l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return Math.round(255 * color);
  };
  const toHex = (v) => v.toString(16).padStart(2, "0");
  return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`;
}

export function getColorForKey(key) {
  const k = String(key || "");
  const h = hashStringToInt(k);
  // pick hue across 0-360
  const hue = h % 360;
  // vary saturation/lightness slightly based on hash to avoid identical tones
  const sat = 60 + (h % 20); // 60-79
  const light = 45 + ((h >>> 8) % 10); // 45-54
  return hslToHex(hue, sat, light);
}

export default getColorForKey;
